/**
 * UNR155ChecklistPage — embed-only.
 *
 * Mounted as the `unr155-checklist` tab body inside ProjectWorkspace
 * at `/project/:projectId/unr155-checklist`. There is no
 * standalone `/athena/unr155-checklist` surface anymore; the
 * post-top-nav-migration cleanup removed it (the top bar nav has
 * only Projects / Library / Vulnerability Management; the standalone
 * route was reachable only via direct URL and dead in practice).
 *
 * The page is a thin wrapper that supplies the body's padding +
 * flex layout. The actual checklist UI lives in `UNR155Tree`.
 */
import React from 'react';
import UNR155Tree from './UNR155Tree';
import styles from './UNR155ChecklistPage.module.css';

const UNR155ChecklistPage = ({ projectId }) => (
  <div className={styles.pageBody}>
    <UNR155Tree sessionId={projectId} />
  </div>
);

export default UNR155ChecklistPage;
